import './css_imports.js';
import './maps.js';
import 'altcha';

import {
  Calendar,
  BusinessHoursInput,
  EventSourceFuncArg,
  EventApi,
  formatDate
} from '@fullcalendar/core'

import type {
  EventInput
} from '@fullcalendar/core'


import skLocale from '@fullcalendar/core/locales/sk';
import interactionPlugin from '@fullcalendar/interaction'
//import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import momentTimezonePlugin from '@fullcalendar/moment-timezone'

import buttonsViewPlugin from './buttonsview';

//import { ordinacneHodiny } from './ordinacne_hodiny'

// altcha

$altcha.i18n.set('sk', {
  ariaLinkLabel: "Navštívte Altcha.org",
  enterCode: "Zadajte kód",
  enterCodeAria: "Zadajte kód, ktorý počujete. Stlačením medzerníka prehráte zvuk.",
  error: "Verifikácia zlyhala. Skúste to znova neskôr.",
  expired: "Verifikácia vypršala. Skúste to znova.",
  footer: 'Chránené <a href="https://altcha.org/" target="_blank" aria-label="Navštívte Altcha.org">ALTCHA</a>',
  getAudioChallenge: "Získať audio výzvu",
  label: "Nie som robot",
  loading: "Načítava sa...",
  reload: "Obnoviť",
  verify: "Verifikovať",
  verificationRequired: "Vyžaduje sa overenie!",
  verified: "Verifikované",
  verifying: "Prebieha verifikácia...",
  waitAlert: "Prebieha verifikácia... prosím čakajte.",
  cancel: "Zrušiť",
  enterCodeFromImage: "Na pokračovanie, prosím, zadajte kód z obrázka nižšie."
});

$altcha.defaults.set({
  //challenge: 'https://beda.dcs.fmph.uniba.sk/ads/devel/amident/altcha_challenge.php',
  challenge: window.location.origin + '/altcha_challenge.php',
  //debug: true,
  language: 'sk',
  hideLogo: true

});

/* run a function after DOM is loaded */
function fire(f: () => void) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", f);
  } else {
    f();
  }
}

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { Navigation, Pagination } from 'swiper/modules';

let swiper: Swiper | null;

fire(() => {
  swiper = new Swiper('#main-swiper', {
    modules: [
      //  Navigation, 
      Pagination,
      // EffectFlip,
      Autoplay],
    // Optional parameters
    direction: 'horizontal',
    //effect:'flip',
    loop: true,
    speed: 650,
    //centeredSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    /*
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    */

  });
});

// navbar-burgers should toggle menu
fire(() => {
  // Get all "navbar-burger" elements
  const nbs = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
  // Add a click event on each of them
  nbs.forEach(el => {
    el.addEventListener('click', () => {
      // Get the target from the "data-target" attribute
      const dt = el.dataset.target;
      const target = document.getElementById(dt);
      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      if (el) el.classList.toggle('is-active');
      if (target) target.classList.toggle('is-active');

    });
  });
});

// Functions to open and close a modal
function openModal(el: Element) {
  document.documentElement.classList.add('is-clipped');
  el.classList.add('is-active');
}

function closeModal(el: Element) {
  document.documentElement.classList.remove('is-clipped');
  el.classList.remove('is-active');
}

function closeAllModals() {
  (document.querySelectorAll('.modal') || []).forEach((mdl) => {
    closeModal(mdl);
  });
}


function openLoader() {
  document.documentElement.classList.add('is-clipped');
  const loadingModal = document.getElementById("loading-modal")!;
  loadingModal.classList.add("is-active");
}

function closeLoader() {
  document.documentElement.classList.remove('is-clipped');
  const loadingModal = document.getElementById("loading-modal")!;
  loadingModal.classList.remove("is-active");
}



// modal functionality
fire(() => {
  const elems = document.getElementsByClassName("navbar-item");
  for (let i = 0; i < elems.length; i++)
    elems[i].addEventListener('mousedown', function(event) { event.preventDefault(); });

  // Add a click event on buttons to open a specific modal
  (document.querySelectorAll('.js-modal-trigger') || []).forEach((trig) => {
    if (!(trig instanceof HTMLElement)) return;
    const mdl = trig.dataset.target;
    if (!mdl) return;
    const trg = document.getElementById(mdl);

    if (trg) trig.addEventListener('click', () => {
      openModal(trg);
    });
  });

  // Add a click event on various child elements to close the parent modal
  (document.querySelectorAll('.modal-close, .modal-card-head .delete, .modal-ok-button') || []).forEach((cls) => { // .button, .modal-card-foot .button, .modal-background
    const trg = cls.closest('.modal')!;
    cls.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal(trg);
    });
  });

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', (event) => {
    if (event.key === "Escape") {
      closeAllModals();
 }
  });
});

// notification
fire(() => {
  (document.querySelectorAll('.notification .delete') || []).forEach((butt) => {
    const notif = butt.parentNode! as HTMLElement;
    butt.addEventListener('click', () => {
      notif.classList.add('is-hidden');
    });
    notif.addEventListener('click', () => {
      notif.classList.add('is-hidden');
    });

  });
});


function show_notification(msg: string) {
  document.getElementById("notification-text")!.innerHTML=msg;
 openModal(document.getElementById("notification-modal")!);
}

// navigacia
function set_page(name: string, hashname: string = '', push: boolean = true) {
  // pripadne pridaj do historie
  if (push) history.pushState([name, hashname], window.location.toString());

  swiper!.autoplay.stop();

  // vypni main-div
  const elems = document.getElementsByClassName("main-div");
  for (let i = 0; i < elems.length; i++)
    elems[i].classList.add('is-hidden');

  // zapni main-div-<name>
  const visible_elems = document.getElementsByClassName("main-div-" + name);
  for (let i = 0; i < visible_elems.length; i++)
    visible_elems[i].classList.remove('is-hidden');

  // pripadne skoc na podstranku
  if (hashname)
    setTimeout(function() {
      document.getElementById(hashname)!.scrollIntoView({ block: "start", behavior: "instant" });
    }, 5);

  //ak bol zapnuty burger, tak ho vypni
  const brg = document.getElementById('main-burger')!;
  if (brg.classList.contains('is-active')) {
    brg.classList.toggle('is-active');
    document.getElementById('main-navbar-menu')!.classList.toggle('is-active');
  }

  if (name == 'home')
    requestAnimationFrame(() => {
      swiper!.update();
      swiper!.autoplay.start();
    });

}

/*
 * 'back' gombik browsera (set_page da do historie polozku)
 */
window.addEventListener("popstate", (event: PopStateEvent) => {
  let state: string[] = ['home', ''];
  if (event.state && event.state[0]) state[0] = event.state[0];
  if (event.state && event.state[1]) state[1] = event.state[1];
  set_page(state[0], state[1], false);
});


// set navigation from html elements
fire(() => {
  document.addEventListener('click', (e: MouseEvent) => {
    const el: HTMLElement | null = (e.target as Element).closest('.js-set-page');
    if (!el) return;

    e.preventDefault();

    const pagename: string = el.dataset.pagename || '';
    const pagehash: string = el.dataset.pagehash || '';

    set_page(pagename, pagehash);
  });
});

// fill in mail address
function FillSensitive(s: string, v1: number[], v2: number[], is_mail: boolean) {
  let v: string = '';
  for (const i in v1) {
    v = v + String.fromCharCode(v1[i] ^ v2[i]);
  }

  const tags = document.querySelectorAll<HTMLAnchorElement>(s);
  for (const tag of tags) {
    tag.innerText = v;
    if (is_mail) {
      tag.href = "mailto:" + v;
    }
  }
}

fire(() => {
  FillSensitive(".fill-mail", [228, 37, 174, 116, 233, 215, 113, 105, 76, 148, 166, 237, 252, 37, 49], [141, 75, 200, 27, 169, 182, 28, 0, 40, 241, 200, 153, 210, 86, 90], true);
});


// send message
fire(() => {
  document.querySelector<HTMLFormElement>('#mail-form')!.addEventListener('submit', async (e: SubmitEvent) => {
    openLoader();
    e.preventDefault();
    const formData = new FormData(e.currentTarget as HTMLFormElement);
    try {
      const response = await fetch('send_message.php', {
        method: 'POST',
        body: formData,
        headers: {
          "Cache-Control": "no-cache"
        }
      });
      const result = (await response.json());
      console.log('Success:', result);
      closeLoader();
      closeModal(document.querySelector<HTMLFormElement>('#message-modal')!);
      if (result.status == 'ok')
        show_notification('Správa bola úspešne odoslaná. Hneď, ako to bude možné, Vás budeme kontaktovať.');
      else
        show_notification('Ľutujeme, pri posielaní správy nastala chyba.');

    } catch (error) {
      console.error('Error submitting form:', error);
    }
  });
});


// send reservation
fire(() => {
  const form = document.querySelector<HTMLFormElement>('#rezervacia-form')!;
  form.addEventListener('submit', async (e: SubmitEvent) => {
    e.preventDefault();
    openLoader();
    //const formData = new FormData(e.currentTarget as HTMLFormElement);
    const formData = new FormData(form);
    fetch("reservation.php", {
      method: "POST",
      body: formData,
      headers: {
        "Cache-Control": "no-cache"
      }
    })
      .then(response => response.text())
      .then(data => {
        closeLoader();
        form.reset();
        document.querySelector<HTMLButtonElement>('#sendreservation')!.disabled = true;
        show_notification("<b>Ďakujeme za rezerváciu.</b> Na Váš mail sme poslali overovací link, kliknite naňho pre potvrdenie rezervácie. <br/><br/> Niektoré mailové programy blokujú automaticky posielané správy. Ak Vám v priebehu niekoľkých minút mail nepríde, prosím, skontrolujte si priečinok so spamom. <br/><br/>V prípade problémov nás kontaktujte <a class=\"my-link\" href=\"tel:+421903770222\" target=_blank><i class=\"fa-solid fa-phone\"></i><b>&nbsp; +421&nbsp;903&nbsp;770&nbsp;222</b> </a> ");

      })
      .catch(error => {
        console.error("Error:", error);
      });
  });
});


// *********************************
// calendar

class LocalEvent {
  constructor(
    public start: Date = new Date(0),
    public end: Date = new Date(0),
    public type: string = 'free',
    public eid: number = 0,
  ) { }
}

/* size of an object */
function size(o: Object): number {
  return Object.keys(o).length;
}

/* main calendar */
let calendar: Calendar | null;

/* currently requested range of days or null */
let currentInfo: EventSourceFuncArg | null;

/* database cache: key is info.startStr */
let sharedEvents: { [key: string]: LocalEvent[] } = {};

/* fetch data from database, based on currentInfo; run callback when data arrive */
function fetchShared(callback: Function = () => { }) {
  //console.log('fetchShared called');
  let key = currentInfo!.startStr;

  fetch("events.php", {
    method: "POST",
    body: JSON.stringify(currentInfo),
    headers: {
      "Cache-Control": "no-cache"
    }
  })
    .then(response => response.text())
    .then(data => {
      sharedEvents[key] = JSON.parse(data);
      if (calendar && currentInfo!.startStr == key)
        calendar.getEventSourceById('sharedEvents')!.refetch();
      callback();
    })
    .catch(error => {
      console.error("Error:", error);
      callback();
    });
}

/* periodically run fetchShared (every 5 sec) */
function backgroundFetcher() {
  setTimeout(() => { fetchShared(backgroundFetcher); }, 5000);
}

const now = new Date();
const startOfMonth =
    `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;


/* main calendar setup */
fire(() => {
  const calendarEl = document.getElementById('CAL')!
  calendar = new Calendar(calendarEl, {
    plugins: [
      momentTimezonePlugin,
      buttonsViewPlugin
    ],
    height: 'auto',
    locale: skLocale,
    timeZone: 'Europe/Bratislava',
    initialView: 'buttons',
    selectable: true,
    unselectAuto: false,
    editable: false,
    headerToolbar: {
      start: 'today',
      center: 'title',
      end: 'prev,next'
    },
    lazyFetching: false,
    duration: { months: 1 },
    validRange: { start: startOfMonth },
    eventSources:
      [
        {
          id: 'sharedEvents',
          events:
            function(info, successCallback, failureCallback) {
              if (!currentInfo || info.startStr != currentInfo.startStr) {
                currentInfo = info;
                fetchShared();
              }
              let data: EventInput[] = [];
              const evts = sharedEvents[info.startStr] || [];
              for (const evt of evts) {
                let x: EventInput = { ...evt };
                switch (evt.type) {
                  case 'free': x.title = 'voľný'; break;
                  case 'pending': x.title = 'rezervácia'; break;
                  case 'assigned': x.title = 'obsadený'; break;
                }
                x.editable = false;
                data.push(x);
              }
              successCallback(data);
            }
        }
      ],
  });
  backgroundFetcher();
  calendar!.render();
});

document.addEventListener("click", (event) => {
  const target = event.target as HTMLElement;

  // Find closest button with the class (handles nested elements inside button)
  const button = target.closest(".is-view-button") as HTMLButtonElement | null;


  if (!button) return;
  const eid = button.dataset.eid!;

  document.querySelector<HTMLInputElement>('#eidinput')!.value = eid;
  document.querySelector<HTMLButtonElement>('#sendreservation')!.disabled = false;
  const date = new Date(button.dataset.start as string);

  document.querySelector<HTMLInputElement>('#timeinputstring')!.value =
    formatDate(date, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'Europe/Bratislava',
      locale: 'sk'
    });

});

